export const PinConfig = {
  pinSize: 18,
  pinMinOpacity: 0.35,
  pinDialogWidth: 330,
  pinDialogOffset: 6,
};

export const UiModes = {
  collapsed: 0,
  assembly: 1,
  markup: 2,
  geometry: 3,
  feature: 4,
  wallFeature: 5,
  mesh: 6,
  section: 7,
  measurements: 8,
};

export const AssemblyModes = {
  tree: 0,
  bom: 1,
};

export const MeshAnalysisModes = {
  features: 0,
  overhang: 1,
  sharpness: 2,
  thickness: 3,
};

export const NavCubeConfig = {
  size: 80,
  offsetY: 30,
  offsetX: 30,
};

export const UiPosition = {
  top: 37,
  panel: 300,
  largePanel: 800,
  bigPanel: 500,
};

export const UiTimerDelays = {
  xShort: 0,
  short: 10,
  default: 100,
  medium: 500,
  large: 1000,
  xlarge: 2000,
};

const addPX = number => `${number}px`;

// Be careful changing those values, they are being used for making calculations
const constIconsSize = 18;
const constTreeIndent = 16;
const constTreeNodeHeight = 24;

const constSlideBarSize = 20;
const constWidth = 44;
const constHeight = 34;
const constDesktopWidth = 32;
const constDesktopPanel = UiPosition.panel;
const constDesktopLargePanel = UiPosition.largePanel;

export const BlockSize = {
  constIconsSize,
  constTreeIndent,
  constTreeNodeHeight,

  constSlideBarSize,
  iconsSize: addPX(constIconsSize),
  constWidth,
  constHeight,
  constDesktopWidth,
  constDesktopPanel,
  constDesktopLargePanel,
  width: addPX(constWidth),
  height: addPX(constHeight),
  desktopWidth: addPX(constDesktopWidth),
  desktopHeight: addPX(constDesktopWidth),
  desktopPanel: addPX(constDesktopPanel),
  desktopLargePanel: addPX(constDesktopLargePanel),
  circle: '19.5px',
  iconCircle: '10px',
};
